import * as React from 'react';
/**
 *
 * Original name: suggest edit
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=32425%3A9861
 *
 */
export const SuggestEditLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.363 8.73a2.252 2.252 0 0 0 0-3.182l-.378-.38a2.253 2.253 0 0 0-3.182 0L5.69 12.28 5 16.53l4.25-.691 7.113-7.11Zm-1.439-2.5.379.378a.75.75 0 0 1 0 1.061l-.788.787-1.45-1.43.797-.796a.75.75 0 0 1 1.062 0Zm-8.109 8.487L7.095 13l4.91-4.911 1.45 1.43-4.922 4.919-1.718.28Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M5 18h2.25v1.5H5V18Zm3.917 0h2.25v1.5h-2.25V18Zm3.916 0h2.25v1.5h-2.25V18ZM19 18h-2.25v1.5H19V18Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
